import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract, chinaContract12 } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import { getTxGasConfig } from "../getTxGasConfig";

const usePurchaseNFTwithGems = () => {
  const { account, chainId } = useWeb3React();
  const web3 = useWeb3();

  const contractType = Environment?.presale?.contractVersion;
  const isFirstContractVersion = contractType === "v0";

  const tokenAddress = Environment.presaleContract;

  const contract = isFirstContractVersion
    ? chinaContract(tokenAddress, web3)
    : chinaContract12(tokenAddress, web3);

  const GemsAddress = Environment.gems;

  const purchaseNFTwithGems = useCallback(
    async (
      postApiRes,
      currentRound,
      nftPriceArray,
      price,
      nftPriceArray1,
      balance,
      index,
      checkBox,
    ) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      // Convert GEMS amount to mwei
      let amount = nftPriceArray1 / price;
      amount = parseFloat(amount).toFixed(6);
      const valueInWei = web3.utils.toWei(amount.toString(), "mwei");

      console.log("NFT GEMS purchase params:", {
        GemsAddress,
        nftPriceArray,
        valueInWei,
      });

      try {
        return new Promise(async (resolve, reject) => {
          const args = isFirstContractVersion
            ? [
                GemsAddress,
                postApiRes.price,
                postApiRes.normalizationFactorNft,
                postApiRes.code,
                currentRound,
                nftPriceArray,
                postApiRes.deadline,
                index,
                postApiRes.agentsAddresses,
                postApiRes.agentsPercentages,
                [],
                "0x",
                postApiRes.v,
                postApiRes.r,
                postApiRes.s,
              ]
            : [
                GemsAddress,
                postApiRes.price,
                postApiRes.normalizationFactorToken,
                postApiRes.normalizationFactorNft,
                postApiRes.code,
                currentRound,
                nftPriceArray,
                postApiRes.deadline,
                index,
                postApiRes.agentsAddresses,
                postApiRes.agentsPercentages,
                [],
                "0x",
                postApiRes.v,
                postApiRes.r,
                postApiRes.s,
              ];

          console.log("BUYING NFT WITH GEMS PARAMS:", args);

          let gas;
          let gasPrice;

          try {
            gasPrice = await web3.eth.getGasPrice();
            gasPrice = parseInt(gasPrice) + 2000000000;

            gas = await contract.methods.purchaseNFTWithToken
              .apply(contract.methods, args)
              .estimateGas({ from: account, gasPrice });
          } catch (err) {
            return reject(err);
          }

          const gasLimit = Math.floor(gas * 1.2);

          const gasConfig = await getTxGasConfig(web3, chainId ?? 1, account);

          contract.methods.purchaseNFTWithToken
            .apply(contract.methods, args)
            .send({ from: account, gas: gasLimit, ...gasConfig })
            .on("transactionHash", (hash) => {
              console.log("NFT GEMS tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("NFT GEMS purchase confirmed:", receipt);
              resolve({
                transactionHash: receipt.transactionHash,
                receipt,
              });
            })
            .on("error", (error) => {
              console.error("NFT GEMS purchase error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3, isFirstContractVersion],
  );

  return { purchaseNFTwithGems };
};

export default usePurchaseNFTwithGems;
